// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {useMemo} from 'react';
import {Text} from '../../comp/text';
import {Icon} from '../../comp/icon';
import store from '../../store.js';
import {P_METHOD_META} from '../../utils/constants.js';
import {Popup_btn} from './popup_btn.js';
import {Method_card} from './method_card.js';
import {Method_picker_connected} from './method_picker_connected.js';
import * as cns from './withdraw_section.module.less';

function Overlay({label}){
    return <div className={cns.card_overlay}>
      <div className={cns.card_overlay_ico_wrap}>
        <Icon ico="arrow_right" size="xxl"/>
      </div>
      <Text.m>{label}</Text.m>
    </div>;
}

function Configured_card({is_cfg, ...trigger_props}){
    return <Method_card {...trigger_props} className={cns.card}
      slot_bottom={<Overlay label={is_cfg ? 'Edit' : 'Cash out'}/>}/>;
}

const render_item = props=><Popup_btn is_redeem trigger_comp={Configured_card}
    trigger_props={props} preselected_method={props.method_id}/>;

function Cfg_btn({redeem_details, is_set}){
    const props = useMemo(()=>{
        const {payment_method, email} = redeem_details || {};
        const meta = P_METHOD_META[payment_method];
        const description = is_set
            ? `via ${meta?.title||payment_method} to ${email}`
            : 'Not set';
        return {
            ico: 'refresh',
            label: 'Auto-redeem',
            active: true,
            description,
            is_cfg: true,
        };
    }, [redeem_details, is_set]);
    return <Popup_btn trigger_comp={Configured_card} trigger_props={props}/>;
}

export function Withdraw_section({className}){
    const [money] = store.use_money();
    const {redeem_details} = money;
    const {payment_method, email} = redeem_details || {};
    const is_set = !!(payment_method&&email);
    const extras = useMemo(()=>[
        <Cfg_btn key="cfg" redeem_details={redeem_details} is_set={is_set}/>,
    ], [redeem_details]);
    return <div className={className}>
      <Text.xl bold>Withdraw</Text.xl>
      <Method_picker_connected className={cns.methods} all_active={!is_set}
        render_item={render_item} extra_items={extras}/>
    </div>;
}
